<template>
  <div>
    <div class="pa-3">
      <v-subheader>Plantilla</v-subheader>
      <v-divider></v-divider>
      <v-item-group class="d-flex align-center flex-wrap mt-2" mandatory style="gap: 20px"
        v-model="opcionesAutoestudio.plantilla">
        <v-item :value="val" v-for="[val, plantilla] in Object.entries(plantillasFormulario)" :key="val"
          v-slot="{ active, toggle }">
          <v-card outlined class="pa-2 pa-2 px-4 rounded-md d-flex" @click="toggle">
            <h4>{{ plantilla.name }}</h4>
          </v-card>
        </v-item>
      </v-item-group>

      <v-item-group v-if="opcionesAutoestudio.plantilla == 'COLABORADORES_EXT'">
        <v-subheader>Colaborador externo</v-subheader>
        <v-divider></v-divider>
        <v-select v-model="opcionesAutoestudio.idColaboradorExterno" :items="colaboradoresExternos" item-text="nombre"
          item-value="id" label="Selecciona una empresa" />
      </v-item-group>
      <br>
      <v-divider></v-divider>
      <br>

      <div v-if="permiteRenting(opcionesAutoestudio.plantilla)">
        <div style="display:flex; width: 100%; gap:5.2rem; padding-left:2rem">
          <v-subheader>Es un EPC?</v-subheader>
          <v-subheader>Es un renting?</v-subheader>
          <v-subheader>Es un PPA?</v-subheader>
        </div>

        <v-divider></v-divider>

        <div style="display:flex; width: 100%; gap:4.6rem; padding-left:2.2rem">
          <v-radio-group v-model="opcionesAutoestudio.es_epc" row mandatory class="mt-2">
            <v-radio label="Si" :value="true"></v-radio>
            <v-radio label="No" :value="false"></v-radio>
          </v-radio-group>
          <v-radio-group v-model="opcionesAutoestudio.es_renting" row mandatory class="mt-2">
            <v-radio label="Si" :value="true"></v-radio>
            <v-radio label="No" :value="false"></v-radio>
          </v-radio-group>
          <v-radio-group v-model="esPpaSeleccionado" row mandatory class="mt-2">
            <v-radio label="Si" :value="true"></v-radio>
            <v-radio label="No" :value="false"></v-radio>
          </v-radio-group>
        </div>
      </div>

    <div>

      <v-subheader>Baterias</v-subheader>
      <v-divider></v-divider>
      <div class="d-flex align-center flex-wrap mt-2" style="gap: 20px">
        <span>Cantidad</span>
        <v-text-field v-model.number="opcionesAutoestudio.baterias" label="Numero de baterias" type="number" min="0"
          step="1" />
        <!-- <v-select v-model="opcionesAutoestudio.baterias" :items="OpcionesVoltajeBaterias" item-text="label"
            item-value="key" label="Selecciona una cantidad" /> -->
      </div>
    </div>

    <v-item-group v-if="opcionesAutoestudio.plantilla == 'NUEVA_AISLADA'">
        <v-subheader>Generador</v-subheader>
        <v-divider></v-divider>
        <v-select v-model="opcionesAutoestudio.idGenerador" :items="generadores" item-value="idGenerador" dense filled
          clearable label="Selecciona un generador (opcional)">
          <template v-slot:selection="{ item }">
            <v-list-item-title>{{ item.nombre }} - {{ formatCurrency(item.precio) }}</v-list-item-title>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.nombre }} - {{ formatCurrency(item.precio) }}</v-list-item-title>
            </v-list-item-content>
          </template>
        </v-select>
      </v-item-group>

    <v-subheader>Lecturas</v-subheader>
    <v-divider></v-divider>
    <v-item-group class="d-flex align-center flex-wrap mt-2" mandatory style="gap: 20px">
      <v-item v-slot="{ active, toggle }">
        <v-card outlined class="pa-2 pa-2 px-4 rounded-md d-flex" @click="
          toggle();
        lecturas_manuales = null;
        ">
          <h4>Lecturas SIPS</h4>
        </v-card>
      </v-item>
      <v-item v-slot="{ active, toggle }">
        <v-card outlined class="pa-2 rounded-md d-flex">
          <v-file-input dense hide-details filled @input="toggle" @change="toggle" v-model="lecturas_manuales"
            hint=".csv" accept=".csv" placeholder="Selecciona tu archivo con las lecturas"></v-file-input>
        </v-card>
      </v-item>
      <v-btn @click.stop="descargarPlantillaLecturas" small color="primary">
        <v-icon left>mdi-download</v-icon>
        Plantilla
      </v-btn>
    </v-item-group>
    <div class="my-2"></div>
    <v-subheader>Tipo de consumidor</v-subheader>
    <v-divider></v-divider>
    <v-item-group v-model="opcionesAutoestudio.curva" mandatory
      class="d-flex align-center justify-space-around flex-wrap mt-2" style="gap: 20px">
      <v-item v-for="[val, curva] in Object.entries(curvas)" :key="val" :value="val" v-slot="{ toggle }">
        <v-card outlined class="item-selection align-center pa-4 ma-1"
          style="height: 150px; width: 150px; aspect-ratio: 1" @click.stop="toggle">
          <h4>{{ curva.name }}</h4>
          <v-icon large>{{ curva.icon }}</v-icon>
          <v-sparkline :value="curva.curva" color="secondary" line-width="6"></v-sparkline>
        </v-card>
      </v-item>
      <v-text-field style="max-width: 150px;" label="Excedentes" suffix="%"
        v-model="opcionesAutoestudio.excedentes_buscados" dense hide-details filled type="number"></v-text-field>
    </v-item-group>

    <div class="my-2"></div>
    <v-subheader>Tipo de estructura</v-subheader>
    <v-divider></v-divider>
    <v-item-group v-model="opcionesAutoestudio.estructura" mandatory class="d-flex align-center flex-wrap mt-2"
      style="gap: 20px">
      <v-item v-for="val in Object.keys(estructuras)" :key="val" :value="val" v-slot="{ toggle }">
        <v-card outlined class="item-selection align-center pa-2 px-4 ma-1" @click.stop="toggle">
          <h4>{{ val }}</h4>
        </v-card>
      </v-item>
    </v-item-group>

    <div class="my-2"></div>
    <v-subheader>Panel</v-subheader>
    <v-divider></v-divider>
    <v-item-group mandatory class="d-flex align-center flex-wrap mt-2" style="gap: 20px">
      <v-item v-slot="{ active, toggle }">
        <v-card outlined class="pa-2 pa-2 px-4 rounded-md d-flex" @click="
          toggle();
        opcionesAutoestudio.idPanel = null;
        ">
          <h4>Según consumidor</h4>
        </v-card>
      </v-item>

      <v-item v-slot="{ active, toggle }">
        <v-card outlined class="pa-2 rounded-md d-flex">
          <v-select :items="paneles" item-value="idPanel" dense hide-details filled @change="toggle"
            v-model="opcionesAutoestudio.idPanel">
            <template v-slot:selection="{ item }">
              <v-list-item-title>
                {{ item.nombre }}
                -
                {{ item.potencia }} kWp
              </v-list-item-title>
            </template>
            <template v-slot:item="{ item, on, attrs }">
              <v-list-item-content>
                <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                <v-list-item-subtitle>{{ item.potencia }} kWp</v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-select>
        </v-card>
      </v-item>
    </v-item-group>

    <div class="my-2"></div>
    <!-- <v-text-field
                  filled
                  dense
                  hide-details="auto"
                  label="Potencia"
                  type="number"
                  v-model="opcionesAutoestudio.potencia_solicitada"
                ></v-text-field> -->
    <v-subheader>Potencia de la instalación</v-subheader>
    <v-divider></v-divider>
    <v-item-group class="d-flex align-center flex-wrap mt-2" mandatory style="gap: 20px">
      <v-item v-slot="{ active, toggle }">
        <v-card outlined class="pa-2 pa-2 px-4 rounded-md d-flex" @click="
          toggle();
        opcionesAutoestudio.potencia_solicitada = null;
        ">
          <h4>Optimización automática</h4>
        </v-card>
      </v-item>
      <v-item v-slot="{ active, toggle }">
        <v-card outlined class="pa-2 pa-2 px-4 rounded-md d-flex" :disabled="!estudio.cubiertas" @click="
          toggle();
        opcionesAutoestudio.potencia_solicitada = 'Coste 0';
        ">
          <h4>Estudio coste 0</h4>
        </v-card>
      </v-item>
      <v-item v-slot="{ active, toggle }">
        <v-card outlined class="pa-2 rounded-md d-flex">
          <v-text-field dense hide-details filled suffix="kWp" @input="toggle" type="number"
            v-model="opcionesAutoestudio.potencia_solicitada"></v-text-field>
        </v-card>
      </v-item>
    </v-item-group>

    <v-divider class="my-2"></v-divider>

    <template v-if="$root.acceso('EDITAR_ESTUDIOS')">
      <v-subheader>Precio de la instalación</v-subheader>
      <v-divider></v-divider>
      <v-item-group v-model="opcionesAutoestudio.modo_precio" class="d-flex align-center flex-wrap mt-2" mandatory
        style="gap: 20px">
        <v-item value="CONSUMIDOR" v-slot="{ active, toggle }">
          <v-card outlined class="pa-2 pa-2 px-4 rounded-md d-flex" @click="
            debugLog('[EstudioExpress] click modo_precio: CONSUMIDOR');
          toggle();
          opcionesAutoestudio.precio_wp = null;
          ">
            <h4>Calcular según potencia</h4>
          </v-card>
        </v-item>
        <v-item value="PRECIO_FINAL" v-slot="{ active, toggle }">
          <v-card outlined class="pa-2 pa-2 px-4 rounded-md d-flex" @click="
            debugLog('[EstudioExpress] click modo_precio: PRECIO_FINAL');
          toggle();
          opcionesAutoestudio.precio_wp = null;
          ">
            <h4>Precio final</h4>
          </v-card>
        </v-item>
        <v-card outlined class="pa-2 rounded-md d-flex">
          <v-text-field dense hide-details filled :suffix="precioWpSuffix"
            @input="debugLog('[EstudioExpress] input precio_wp')" type="number"
            v-model="opcionesAutoestudio.precio_wp"></v-text-field>
        </v-card>
      </v-item-group>
    </template>

    <v-subheader>Superficie disponible</v-subheader>
    <v-divider></v-divider>
    <v-item-group class="d-flex align-center flex-wrap mt-2" mandatory style="gap: 20px">
      <v-item v-slot="{ active, toggle }">
        <v-card outlined class="pa-2 pa-2 px-4 rounded-md d-flex" @click="
          toggle();
        opcionesAutoestudio.superficie_disponible = null;
        ">
          <h4>Indefinida</h4>
        </v-card>
      </v-item>
      <v-item v-slot="{ active, toggle }">
        <v-card outlined class="pa-2 pa-2 px-4 rounded-md d-flex" :disabled="!estudio.cubiertas" @click="
          toggle();
        opcionesAutoestudio.superficie_disponible = 'cubiertas';
        ">
          <h4>Según cubiertas marcadas</h4>
        </v-card>
      </v-item>
      <v-item v-slot="{ active, toggle }">
        <v-card outlined class="pa-2 rounded-md d-flex">
          <v-text-field dense hide-details filled suffix="m2" @input="toggle" type="number"
            v-model="opcionesAutoestudio.superficie_disponible"></v-text-field>
        </v-card>
      </v-item>
    </v-item-group>

    <template v-if="$root.acceso('EDITAR_ESTUDIOS')">
      <v-divider></v-divider>
      <v-subheader>Término opcional *<small>Se aplicará al precio de instalación</small></v-subheader>
      <v-row class="align-center">
        <v-col>
          <v-text-field dense hide-details filled suffix="€" type="number"
            v-model="opcionesAutoestudio.precio_extra"></v-text-field>
        </v-col>
        <v-col>
          <v-text-field dense hide-details filled suffix="%" type="number"
            v-model="opcionesAutoestudio.precio_extra_pct"></v-text-field>
        </v-col>
      </v-row>
    </template>

    <v-divider class="my-2"></v-divider>

    <v-subheader>Modificar Backup</v-subheader>
    <v-divider></v-divider>
    <v-item-group v-model="opcionesAutoestudio.modo_backup" class="d-flex align-center flex-wrap mt-2" mandatory
      style="gap: 20px">
      <v-item value="SIN_BACKUP" v-slot="{ toggle }">
        <v-card outlined class="pa-2 pa-2 px-4 rounded-md d-flex" @click="toggle()">
          <h4>Sin Backup</h4>
        </v-card>
      </v-item>
      <v-item value="MANUAL" v-slot="{ toggle }">
        <v-card outlined class="pa-2 pa-2 px-4 rounded-md d-flex" @click="toggle()">
          <h4>Backup Manual</h4>
        </v-card>
      </v-item>
      <v-item value="AUTOMATICO" v-slot="{ toggle }">
        <v-card outlined class="pa-2 pa-2 px-4 rounded-md d-flex" @click="toggle()">
          <h4>Backup Automático</h4>
        </v-card>
      </v-item>

    </v-item-group><br>
    <v-divider></v-divider>
    <v-subheader>Simulación comunidad</v-subheader>
    <v-text-field placeholder="Nº vecinos" filled dense hide-details v-model="opcionesAutoestudio.simulacion_vecinos"
      type="number"></v-text-field>

    <v-divider class="my-2"></v-divider>

    <v-row>
      <v-col cols="12" md="4">
        <v-text-field filled dense hide-details="auto" label="Precio medio kWh" type="number"
          v-model="opcionesAutoestudio.precio_medio"></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field filled dense hide-details="auto" label="Inclinación" type="number"
          v-model="opcionesAutoestudio.inclinacion" suffix="º" :disabled="!!estudio.inclinacion"></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field filled dense hide-details="auto" label="Azimut" type="number" v-model="opcionesAutoestudio.azimut"
          suffix="º" :disabled="!!estudio.azimut"></v-text-field>
      </v-col>
    </v-row>

    <v-divider class="my-2"></v-divider>

    <v-row class="align-center">
      <v-col cols="12" md="3">
        <v-checkbox filled dense hide-details="auto" v-model="opcionesAutoestudio.calcular_financiacion"
          label="Incluir financiacion"></v-checkbox>
      </v-col>
      <v-col cols="12" md="4" v-if="$root.acceso('EDITAR_ESTUDIOS')">
        <v-text-field filled dense hide-details="auto" type="number" v-model="opcionesAutoestudio.interes"
          :disabled="!opcionesAutoestudio.calcular_financiacion" label="Interes anual"></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field filled dense hide-details="auto" type="number" label="Años financiacion"
          v-model="opcionesAutoestudio.años_financiacion"
          :disabled="!opcionesAutoestudio.calcular_financiacion"></v-text-field>
      </v-col>
    </v-row>

    <v-divider class="my-2"></v-divider>

    <v-row>
      <v-col cols="12">
        <v-checkbox filled dense hide-details="auto" v-model="opcionesAutoestudio.aplicar_iva"
          label="Aplicar IVA"></v-checkbox>
      </v-col>
    </v-row>
    <div class="my-2"></div>
    <v-subheader>Promoción</v-subheader>
    <v-divider></v-divider>
    <v-item-group v-model="opcionesAutoestudio.promocion" mandatory class="d-flex align-center flex-wrap mt-2"
      style="gap: 20px">
      <v-item :value="null" v-slot="{ toggle }">
        <v-card outlined class="item-selection align-center pa-2 px-4 ma-1" @click.stop="toggle">
          <h4>Automático</h4>
        </v-card>
      </v-item>
      <v-item value="NINGUNA" v-slot="{ toggle }">
        <v-card outlined class="item-selection align-center pa-2 px-4 ma-1" @click.stop="toggle">
          <h4>Ninguna</h4>
        </v-card>
      </v-item>
      <v-item v-for="val in promociones" :key="val.idPromocion" :value="val.idPromocion" v-slot="{ toggle }">
        <v-card outlined class="item-selection align-center pa-2 px-4 ma-1" @click.stop="toggle">
          <h4>{{ val.nombre }}</h4>
        </v-card>
      </v-item>
    </v-item-group>

    <div class="my-2"></div>
    <v-subheader>Subvencion</v-subheader>
    <v-divider></v-divider>
    <v-item-group v-model="opcionesAutoestudio.subvencion" mandatory class="d-flex align-center flex-wrap mt-2"
      style="gap: 20px">
      <v-item :value="null" v-slot="{ toggle }">
        <v-card outlined class="item-selection align-center pa-2 px-4 ma-1" @click.stop="toggle">
          <h4>No</h4>
        </v-card>
      </v-item>
      <v-item v-for="[val, name] in Object.entries(subvenciones)" :key="val" :value="val" v-slot="{ toggle }">
        <v-card outlined class="item-selection align-center pa-2 px-4 ma-1" @click.stop="toggle">
          <h4>{{ name }}</h4>
        </v-card>
      </v-item>
    </v-item-group>

    <div v-if="esPpaSeleccionado">
      <div class="my-2"></div>
      <v-subheader>PPA</v-subheader>
      <v-divider></v-divider>
      <v-item-group v-model="opcionesAutoestudio.ppa" mandatory class="d-flex align-center flex-wrap mt-2"
        style="gap: 20px">
        <v-item v-for="[val, ppa] in Object.entries(ppas)" :key="val" :value="val" v-slot="{ toggle }">
          <v-card outlined class="item-selection align-center pa-2 px-4 ma-1" @click.stop="toggle">
            <h4>{{ ppa.name }}</h4>
          </v-card>
        </v-item>
      </v-item-group>
    </div>

    <v-divider class="my-2"></v-divider>

    <v-row class="align-center">
      <v-col cols="12" md="3">
        <v-checkbox filled dense hide-details="auto" v-model="opcionesAutoestudio.precio_oferta_alumbra"
          label="Oferta Alumbra"></v-checkbox>
      </v-col>
      <v-col cols="12" md="4" v-if="$root.acceso('EDITAR_ESTUDIOS')">
        <v-text-field filled dense hide-details="auto" type="number"
          v-model="opcionesAutoestudio.precio_oferta_compra_alumbra"
          :disabled="!opcionesAutoestudio.precio_oferta_alumbra" required label="Precio compra"
          placeholder="0.08"></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field filled dense hide-details="auto" type="number" label="Precio venta"
          v-model="opcionesAutoestudio.precio_oferta_venta_alumbra" required v-bind:value="{ number: 0.03 }"
          :disabled="!opcionesAutoestudio.precio_oferta_alumbra"></v-text-field>
      </v-col>
    </v-row>

    <div class="my-2"></div>
    <v-divider class="my-2"></v-divider>
    <v-checkbox filled dense hide-details="auto" v-model="opcionesAutoestudio.precio_ibi"
      label="Deducción IBI"></v-checkbox>
    <v-item-group mandatory class="d-flex align-center flex-wrap mt-2" style="gap: 20px">
      <v-item v-slot="{ active, toggle }">
        <v-card outlined class="pa-2 rounded-md d-flex" @click="toggle()">
          <v-text-field filled dense hide-details="auto" type="number" v-model="opcionesAutoestudio.porcentaje_ibi"
            label="% IBI" :disabled="!opcionesAutoestudio.precio_ibi"
            :rules="[() => !opcionesAutoestudio.precio_ibi || !!opcionesAutoestudio.porcentaje_ibi || 'Este campo es obligatorio.']"></v-text-field>
        </v-card>
      </v-item>
      <v-item v-slot="{ active, toggle }">
        <v-card outlined class="pa-2 rounded-md d-flex" @click="toggle()">
          <v-text-field filled dense hide-details="auto" type="number" v-model="opcionesAutoestudio.anos_ibi"
            label="Años IBI" :disabled="!opcionesAutoestudio.precio_ibi"
            :rules="[() => !opcionesAutoestudio.precio_ibi || !!opcionesAutoestudio.anos_ibi || 'Este campo es obligatorio.']"></v-text-field>
        </v-card>
      </v-item>
      <v-item v-slot="{ active, toggle }">
        <v-card outlined class="pa-2 rounded-md d-flex" @click="toggle()">
          <v-text-field filled dense hide-details="auto" type="number" v-model="opcionesAutoestudio.coste_ibi"
            label="Coste IBI" :disabled="!opcionesAutoestudio.precio_ibi"
            :rules="[() => !opcionesAutoestudio.precio_ibi || !!opcionesAutoestudio.coste_ibi || 'Este campo es obligatorio.']"></v-text-field>
        </v-card>
      </v-item>
    </v-item-group>

  </div>
  <v-dialog :value="error" max-width="500">
    <v-card>
      <v-alert class="ma-0" type="error" outlined text>
        {{ error }}
      </v-alert>
    </v-card>

  </v-dialog>
  </div>
</template>

<script setup>
import { downloadFile } from "@/utils/index.js";
import { useVModel } from "@vueuse/core";
import { ref, watch, computed } from "vue";
import axios from "@/utils/axiosWrapper";

const props = defineProps({
  idEstudio: Number,
  estudio: Object,
  value: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits([
  "update:creatingAutoestudio",
  "update:value",
  "reload",
]);

const opcionesAutoestudio = useVModel(props, "value", emit);

function getDefaultAngleValue(value) {
  return value === null || value === undefined || value === "" ? 0 : value;
}

opcionesAutoestudio.value = {
  plantilla: "NUEVA_ESTANDAR_BATERIAS",
  curva: "SERVICIO_GENERAL",
  baterias: 0,
  es_epc: true,
  es_renting: false,
  es_ppa: false,
  precio_medio: 0.14,
  show: false,
  potencia_solicitada: null,
  calcular_financiacion: true,
  modo_precio: "CONSUMIDOR",
  modo_backup: "SIN_BACKUP",
  precio_wp: null,
  precio_extra: 0,
  precio_extra_pct: 1,
  inclinacion: getDefaultAngleValue(props.estudio.inclinacion),
  azimut: getDefaultAngleValue(props.estudio.azimut),
  superficie_disponible: null,
  simulacion_vecinos: null,
  idColaboradorExterno: null,
  idGenerador: null,
  aplicar_iva: false,
  promocion: null,
  precio_oferta_alumbra: true,
  precio_oferta_venta_alumbra: 0,
  precio_oferta_compra_alumbra: 0,
  precio_ibi: false,
  porcentaje_ibi: null,
  anos_ibi: null,
  coste_ibi: null,
  ...opcionesAutoestudio.value,
};

opcionesAutoestudio.value.es_epc = opcionesAutoestudio.value.es_epc ?? true;
opcionesAutoestudio.value.es_renting = opcionesAutoestudio.value.es_renting ?? false;
opcionesAutoestudio.value.es_ppa = opcionesAutoestudio.value.es_ppa ?? false;

const DEFAULT_PPA = "INDUSTRIAL_10";
const esPpaSeleccionado = ref(Boolean(opcionesAutoestudio.value.es_ppa));

watch(
  esPpaSeleccionado,
  (value) => {
    opcionesAutoestudio.value.es_ppa = Boolean(value);
    if (value) {
      if (isEmptyValue(opcionesAutoestudio.value.ppa)) {
        opcionesAutoestudio.value.ppa = DEFAULT_PPA;
      }
      return;
    }
    opcionesAutoestudio.value.ppa = null;
  },
  { immediate: true }
);

const lecturas_manuales = ref(null);

const {
  data,
  error,
  pending: creatingAutoestudio,
  refresh: crearEstudio,
} = axios({
  method: "POST",
  url: `${process.env.VUE_APP_API_URL}/autoestudios/${props.idEstudio}`,
  responseType: "blob",
  headers: {
    "Content-Type": "multipart/form-data",
  },
  timeout: 180000,
  lazy: true,
  block: true,
  transformError: async (err) => {
    try {
      return formatBackendError(JSON.parse(await err.response.data.text()).detail);
    } catch (_parseError) {
      return err?.message || err?.response?.statusText || "No se ha podido generar el autoestudio";
    }
  },
});

watch(creatingAutoestudio, (v) => emit("update:creatingAutoestudio", v));

const { data: plantillas } = axios(
  `${process.env.VUE_APP_API_URL}/autoestudios/plantillas`,
  { default: () => [] }
);

const plantillasFormulario = computed(() => {
  return Object.fromEntries(
    Object.entries(plantillas.value || {}).filter(
      ([key]) => key !== "NUEVA_ESTANDAR"
    )
  );
});

const { data: estructuras } = axios(
  `${process.env.VUE_APP_API_URL}/autoestudios/estructuras`,
  { default: () => [] }
);
const { data: curvas } = axios(
  `${process.env.VUE_APP_API_URL}/autoestudios/curvas`,
  { default: () => ({}) }
);
const { data: paneles } = axios(
  `${process.env.VUE_APP_API_URL}/autoestudios/paneles`,
  { default: () => [] }
);
const { data: generadores } = axios(
  `${process.env.VUE_APP_API_URL}/autoestudios/generadores`,
  { default: () => [] }
);
const { data: promociones } = axios(
  `${process.env.VUE_APP_API_URL}/autoestudios/promociones`,
  { default: () => [] }
);
const { data: subvenciones } = axios(
  `${process.env.VUE_APP_API_URL}/autoestudios/subvenciones`,
  { default: () => [] }
);
const { data: ppas } = axios(
  `${process.env.VUE_APP_API_URL}/autoestudios/ppas`,
  { default: () => [] }
);

const {
  data: colaboradoresExternos,
  refresh: cargarColaboradoresExternos,
} = axios(`${process.env.VUE_APP_API_URL}/colaboradores_externos`, {
  default: () => [],
  lazy: true,
});

const plantillasConRenting = [
  "NUEVA_ESTANDAR",
  "NUEVA_ESTANDAR_BATERIAS",
  "NUEVA_AISLADA",
];

function permiteRenting(plantilla) {
  return plantillasConRenting.includes(plantilla);
}

watch(
  () => opcionesAutoestudio.value?.plantilla,
  (plantilla) => {
    if (isEmptyValue(opcionesAutoestudio.value.baterias)) {
      opcionesAutoestudio.value.baterias = 0;
    }

    if (!permiteRenting(plantilla)) {
      opcionesAutoestudio.value.es_renting = false;
    }

    if (plantilla !== "NUEVA_AISLADA") {
      opcionesAutoestudio.value.idGenerador = null;
    }

    if (
      plantilla === "COLABORADORES_EXT" &&
      (!Array.isArray(colaboradoresExternos.value) ||
        colaboradoresExternos.value.length === 0)
    ) {
      cargarColaboradoresExternos();
    }
  },
  { immediate: true }
);

watch(
  () => opcionesAutoestudio.value?.modo_precio,
  (modoPrecio) => {
    console.log("[EstudioExpress] modo_precio:", modoPrecio);
  }
);

function debugLog(...args) {
  window.console.log(...args);
}

const precioWpSuffix = computed(() => {
  return opcionesAutoestudio.value?.modo_precio === "PRECIO_FINAL"
    ? "EUR"
    : "EUR Wp";
});

function descargarPlantillaLecturas() {
  const plantilla = `Fecha Lectura Anterior;Fecha Lectura;kWh1\n2022/01/01;2022/02/01;0\n2022/02/01;2022/03/01;0\n2022/03/01;2022/04/01;0\n2022/04/01;2022/05/01;0\n2022/05/01;2022/06/01;0\n2022/06/01;2022/07/01;0\n2022/07/01;2022/08/01;0\n2022/08/01;01/09/2022;0\n2022/09/01;2022/10/01;0\n2022/10/01;2022/11/01;0\n2022/11/01;2022/12/01;0\n2022/12/01;2022/12/31;0\n`;
  downloadFile(
    new File([plantilla], "plantilla_lecturas_estudio_express.csv", {}),
    false
  );
}

function isEmptyValue(value) {
  return value === null || value === undefined || value === "";
}

function isPositiveNumber(value) {
  return !isEmptyValue(value) && Number(value) > 0;
}

function isNonNegativeInteger(value) {
  const numericValue = Number(value);
  return (
    !isEmptyValue(value) &&
    Number.isInteger(numericValue) &&
    numericValue >= 0
  );
}

function normalizeNumber(value) {
  if (isEmptyValue(value)) return null;
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
}

function normalizeInteger(value) {
  if (isEmptyValue(value)) return null;
  const numericValue = Number(value);
  return Number.isInteger(numericValue) ? numericValue : null;
}

function formatCurrency(value) {
  const numericValue = Number(value || 0);
  return `${numericValue.toFixed(2)} €`;
}

function formatBackendError(detail) {
  if (Array.isArray(detail)) {
    return detail
      .map((item) => {
        if (item?.loc && item?.msg) {
          return `${item.loc.join(".")}: ${item.msg}`;
        }
        return JSON.stringify(item);
      })
      .join("\n");
  }

  if (detail && typeof detail === "object") {
    return JSON.stringify(detail);
  }

  return String(detail || "No se ha podido generar el autoestudio");
}

function getAnosFinanciacionValue(opciones) {
  if (!opciones) return null;
  return opciones.anos_financiacion ?? opciones["años_financiacion"] ?? null;
}

function getValidationErrors() {
  const errores = [];
  const estudio = props.estudio || {};
  const opciones = opcionesAutoestudio.value || {};
  const cupsPrincipal =
    estudio.cups_principal?.cups || estudio.cups_principal || null;
  const inclinacion = isEmptyValue(estudio.inclinacion)
    ? opciones.inclinacion
    : estudio.inclinacion;
  const azimut = isEmptyValue(estudio.azimut)
    ? opciones.azimut
    : estudio.azimut;
  const anosFinanciacion = getAnosFinanciacionValue(opciones);
  if (anosFinanciacion != null) {
    opciones.anos_financiacion = anosFinanciacion;
    opciones["años_financiacion"] = anosFinanciacion;
  }

  if (!cupsPrincipal) errores.push("Falta el CUPS principal");
  if (isEmptyValue(inclinacion)) errores.push("Falta la inclinacion");
  if (isEmptyValue(azimut)) errores.push("Falta el azimut");
  if (isEmptyValue(estudio.latitud)) errores.push("Falta la latitud");
  if (isEmptyValue(estudio.longitud)) errores.push("Falta la longitud");

  if (
    opciones.plantilla === "COLABORADORES_EXT" &&
    isEmptyValue(opciones.idColaboradorExterno)
  ) {
    errores.push("Falta seleccionar el colaborador externo");
  }

  if (!isNonNegativeInteger(opciones.baterias)) {
    errores.push("Falta indicar una cantidad valida de baterias");
  }

  if (opciones.plantilla === "PPA" && isEmptyValue(opciones.ppa)) {
    errores.push("Falta seleccionar el tipo de PPA");
  }

  if (opciones.precio_ibi) {
    if (!isPositiveNumber(opciones.porcentaje_ibi)) {
      errores.push("Falta el porcentaje de IBI");
    }
    if (!isPositiveNumber(opciones.anos_ibi)) {
      errores.push("Faltan los anos de IBI");
    }
    if (!isPositiveNumber(opciones.coste_ibi)) {
      errores.push("Falta el coste del IBI");
    }
  }

  if (
    !isEmptyValue(opciones.potencia_solicitada) &&
    opciones.potencia_solicitada !== "Coste 0" &&
    !isPositiveNumber(opciones.potencia_solicitada)
  ) {
    errores.push("La potencia solicitada debe ser mayor que 0");
  }

  if (
    !isEmptyValue(opciones.superficie_disponible) &&
    opciones.superficie_disponible !== "cubiertas" &&
    !isPositiveNumber(opciones.superficie_disponible)
  ) {
    errores.push("La superficie disponible debe ser mayor que 0");
  }

  if (
    !isEmptyValue(opciones.precio_medio) &&
    !isPositiveNumber(opciones.precio_medio)
  ) {
    errores.push("El precio medio debe ser mayor que 0");
  }

  if (
    opciones.modo_precio === "PRECIO_FINAL" &&
    !isPositiveNumber(opciones.precio_wp)
  ) {
    errores.push("Falta indicar un precio final valido");
  }

  if (
    !isEmptyValue(opciones.precio_wp) &&
    !isPositiveNumber(opciones.precio_wp)
  ) {
    errores.push("El precio por Wp debe ser mayor que 0");
  }

  if (
    opciones.calcular_financiacion &&
    !isPositiveNumber(getAnosFinanciacionValue(opciones))
  ) {
    errores.push("Faltan los anos de financiacion");
  }

  if (!isEmptyValue(opciones.interes) && Number(opciones.interes) < 0) {
    errores.push("El interes no puede ser negativo");
  }

  if (
    !isEmptyValue(opciones.simulacion_vecinos) &&
    (!Number.isInteger(Number(opciones.simulacion_vecinos)) ||
      Number(opciones.simulacion_vecinos) <= 0)
  ) {
    errores.push("La simulacion de vecinos debe ser un entero mayor que 0");
  }

  if (
    !isEmptyValue(opciones.excedentes_buscados) &&
    (Number(opciones.excedentes_buscados) < 0 ||
      Number(opciones.excedentes_buscados) > 100)
  ) {
    errores.push("Los excedentes buscados deben estar entre 0 y 100");
  }

  if (opciones.precio_oferta_alumbra) {
    if (!isPositiveNumber(opciones.precio_oferta_compra_alumbra)) {
      errores.push("Falta el precio de compra de la oferta Alumbra");
    }
    if (!isPositiveNumber(opciones.precio_oferta_venta_alumbra)) {
      errores.push("Falta el precio de venta de la oferta Alumbra");
    }
  }

  return errores;
}

function buildPayload() {
  const opciones = { ...opcionesAutoestudio.value };
  delete opciones.aisladas;
  const anosFinanciacion = getAnosFinanciacionValue(opciones);

  return {
    tipo: "estudio_express",
    ...opciones,
    aplicar_iva: Boolean(opciones.aplicar_iva),
    calcular_financiacion: Boolean(opciones.calcular_financiacion),
    precio_oferta_alumbra: Boolean(opciones.precio_oferta_alumbra),
    precio_ibi: Boolean(opciones.precio_ibi),
    es_epc: Boolean(opciones.es_epc),
    es_renting: Boolean(opciones.es_renting),
    es_ppa: Boolean(esPpaSeleccionado.value),
    ppa: esPpaSeleccionado.value ? opciones.ppa || DEFAULT_PPA : null,
    potencia_solicitada:
      opciones.potencia_solicitada === "Coste 0"
        ? "Coste 0"
        : normalizeNumber(opciones.potencia_solicitada),
    precio_medio: normalizeNumber(opciones.precio_medio) ?? 0.14,
    modo_backup: opciones.modo_backup || "SIN_BACKUP",
    precio_wp: normalizeNumber(opciones.precio_wp),
    precio_extra: normalizeNumber(opciones.precio_extra) ?? 0,
    precio_extra_pct: normalizeNumber(opciones.precio_extra_pct) ?? 1,
    interes: normalizeNumber(opciones.interes),
    superficie_disponible:
      opciones.superficie_disponible === "cubiertas"
        ? "cubiertas"
        : normalizeNumber(opciones.superficie_disponible),
    simulacion_vecinos: normalizeInteger(opciones.simulacion_vecinos),
    idColaboradorExterno: normalizeInteger(opciones.idColaboradorExterno),
    excedentes_buscados: normalizeInteger(opciones.excedentes_buscados),
    anos_financiacion: normalizeInteger(anosFinanciacion) ?? 10,
    "años_financiacion": normalizeInteger(anosFinanciacion) ?? 10,
    porcentaje_ibi: normalizeNumber(opciones.porcentaje_ibi),
    anos_ibi: normalizeInteger(opciones.anos_ibi),
    coste_ibi: normalizeNumber(opciones.coste_ibi),
    inclinacion: normalizeNumber(opciones.inclinacion),
    azimut: normalizeNumber(opciones.azimut),
    precio_oferta_venta_alumbra: normalizeNumber(
      opciones.precio_oferta_venta_alumbra
    ),
    precio_oferta_compra_alumbra: normalizeNumber(
      opciones.precio_oferta_compra_alumbra
    ),
    baterias: normalizeInteger(opciones.baterias) ?? 0,
    idPanel: normalizeInteger(opciones.idPanel),
    idGenerador: normalizeInteger(opciones.idGenerador),
  };
}

async function estudioExpress() {
  emit("update:creatingAutoestudio", true);
  error.value = null;
  const pdfWindow = window.open("", "_blank");

  if (pdfWindow) {
    pdfWindow.document.write(`
      <!doctype html>
      <html>
        <head>
          <title>Generando PDF...</title>
          <style>
            body {
              margin: 0;
              font-family: Arial, sans-serif;
              display: flex;
              align-items: center;
              justify-content: center;
              min-height: 100vh;
              color: #1f2937;
              background: #f9fafb;
            }
          </style>
        </head>
        <body>Generando PDF...</body>
      </html>
    `);
    pdfWindow.document.close();
  }

  const errores = getValidationErrors();
  if (errores.length > 0) {
    const mensaje = errores.join("\n");
    error.value = mensaje;
    pdfWindow?.close();
    window.alert(mensaje);
    emit("update:creatingAutoestudio", false);
    return;
  }

  const formData = new FormData();
  formData.append(
    "data",
    JSON.stringify(buildPayload())
  );
  if (lecturas_manuales.value)
    formData.append("lecturas_manuales", lecturas_manuales.value);

  const ok = await crearEstudio({ data: formData, block: true });

  if (!ok || error.value) {
    pdfWindow?.close();
    window.alert(error.value || "No se ha podido generar el autoestudio");
    emit("update:creatingAutoestudio", false);
    return;
  }

  if (!data.value) {
    const mensaje = "El servidor no ha devuelto el PDF del autoestudio";
    error.value = mensaje;
    pdfWindow?.close();
    window.alert(mensaje);
    emit("update:creatingAutoestudio", false);
    return;
  }

  const file = new File([data.value], `estudio_express_${props.idEstudio}.pdf`, {
    type: "application/pdf",
  });
  const pdfUrl = URL.createObjectURL(file);

  if (pdfWindow) {
    pdfWindow.document.open();
    pdfWindow.document.write(`
      <!doctype html>
      <html>
        <head>
          <title>${file.name}</title>
          <style>
            html, body {
              margin: 0;
              height: 100%;
              background: #525659;
            }
            iframe {
              border: 0;
              width: 100%;
              height: 100%;
            }
          </style>
        </head>
        <body>
          <iframe src="${pdfUrl}" title="${file.name}"></iframe>
        </body>
      </html>
    `);
    pdfWindow.document.close();
  } else {
    downloadFile(file, true);
  }

  window.setTimeout(() => URL.revokeObjectURL(pdfUrl), 60000);
  emit("reload");
  emit("update:creatingAutoestudio", false);
}

const superficieDisponible = computed(() => {
  return (props.estudio?.cubiertas || []).reduce((p, a) => p + a.area, 0);
});

defineExpose({ estudioExpress })

</script>

<style></style>
